import { CANDIDATE_REPORT, CANDIDATE_REPORT_DOWNLOAD, CANDIDATE_REPORT_DOWNLOAD_FAILED, CANDIDATE_REPORT_DOWNLOAD_SUCCESSFUL, CANDIDATE_REPORT_FAILED, CANDIDATE_REPORT_SUCCESSFUL, JOB_PERFORMANCE_REPORT, JOB_PERFORMANCE_REPORT_DOWNLOAD, JOB_PERFORMANCE_REPORT_DOWNLOAD_FAILED, JOB_PERFORMANCE_REPORT_DOWNLOAD_SUCCESSFUL, JOB_PERFORMANCE_REPORT_FAILED, JOB_PERFORMANCE_REPORT_SUCCESSFUL, JOB_REPORT, JOB_REPORT_DOWNLOAD, JOB_REPORT_DOWNLOAD_FAILED, JOB_REPORT_DOWNLOAD_SUCCESSFUL, JOB_REPORT_FAILED, JOB_REPORT_SUCCESSFUL } from "./actionType"


export const getCandidateMasterReport = user => {
  return {
    type: CANDIDATE_REPORT,
    payload: { user },
  }
}

export const getCandidateMasterReportSuccessful = user => {
  return {
    type: CANDIDATE_REPORT_SUCCESSFUL,
    payload: user,
  }
}

export const getCandidateMasterReportFailed = user => {
  return {
    type: CANDIDATE_REPORT_FAILED,
    payload: user,
  }
}

export const getReportDownload = user => {
  return {
    type: CANDIDATE_REPORT_DOWNLOAD,
    payload: { user },
  }
}

export const getReportDownloadSuccessfull = user => {
  return {
    type: CANDIDATE_REPORT_DOWNLOAD_SUCCESSFUL,
    payload: user,
  }
}

export const getReportDownloadFailed = user => {
  return {
    type: CANDIDATE_REPORT_DOWNLOAD_FAILED,
    payload: user,
  }
}


export const getJobMasterReport = user => {
  return {
    type:JOB_REPORT,
    payload: { user },
  }
}

export const getJobMasterReportSuccessful = user => {
  return {
    type: JOB_REPORT_SUCCESSFUL,
    payload: user,
  }
}

export const getJobMasterReportFailed = user => {
  return {
    type: JOB_REPORT_FAILED,
    payload: user,
  }
}

export const getJobReportDownload = user => {
  return {
    type: JOB_REPORT_DOWNLOAD,
    payload: { user },
  }
}

export const getJobReportDownloadSuccessfull = user => {
  return {
    type: JOB_REPORT_DOWNLOAD_SUCCESSFUL,
    payload: user,
  }
}

export const getJobReportDownloadFailed = user => {
  return {
    type: JOB_REPORT_DOWNLOAD_FAILED,
    payload: user,
  }
}



export const getJobPerformanceReport = user => {
  return {
    type:JOB_PERFORMANCE_REPORT,
    payload: { user },
  }
}

export const getJobPerformanceReportSuccessful = user => {
  return {
    type: JOB_PERFORMANCE_REPORT_SUCCESSFUL,
    payload: user,
  }
}

export const getJobPerformanceReportFailed = user => {
  return {
    type: JOB_PERFORMANCE_REPORT_FAILED,
    payload: user,
  }
}

export const getJobPerformanceReportDownload = user => {
  return {
    type: JOB_PERFORMANCE_REPORT_DOWNLOAD,
    payload: { user },
  }
}

export const getJobPerformanceReportDownloadSuccessfull = user => {
  return {
    type: JOB_PERFORMANCE_REPORT_DOWNLOAD_SUCCESSFUL,
    payload: user,
  }
}

export const getJobPerformanceReportDownloadFailed = user => {
  return {
    type: JOB_PERFORMANCE_REPORT_DOWNLOAD_FAILED,
    payload: user,
  }
}
